A currency supported by the SEEK API.

This may be used when specifying a price or salary range.
